import clsx from "clsx";
import * as React from "react";
import { IAlertProps } from ".";

const Alert: React.FC<IAlertProps> = ({
    type = "info",
    iconType,
    title,
    classes = {},
    container = {},
    ...props
}) => {
    iconType = iconType ? iconType : type;

    let icon = null;
    switch (iconType) {
        case "info":
            icon = "fas fa-info-circle";
            break;
        case "success":
            icon = "fas fa-check-circle";
            break;
        case "error":
            icon = "fas fa-exclamation-circle";
            break;
    }

    return (
        <div
            {...container}
            className={clsx(classes.container, "tmp-alert", {
                "tmp-alert__info": type === "info",
                "tmp-alert__success": type === "success",
                "tmp-alert__error": type === "error",
            })}
        >
            {icon && <i className={clsx(icon, classes.icon, "tmp-alert__icon")} />}
            {title && <h5 className={clsx(classes.title, "tmp-alert__title")}>{title}</h5>}
            <div className={clsx(classes.description, "tmp-alert__description")}>
                {props.children}
            </div>
        </div>
    );
};

export default Alert;
